// extracted by mini-css-extract-plugin
module.exports = {"root":"mediaViewer_root__3K0QD","media":"mediaViewer_media__11W5R"};